// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pxjX","content":"styles_content__1Gu74"};